
"use client";

// Globální CSS proměnné pro sjednocení velikostí písma a responsivitu
if (typeof window !== 'undefined' && !document.getElementById('font-vars')) {
  const style = document.createElement('style');
  style.id = 'font-vars';
  style.innerHTML = `
    :root {
      --fz-lg: clamp(1.7rem, 4vw, 2.2rem);
      --fz-md: clamp(1.08rem, 2.5vw, 1.25rem);
      --fz-base: clamp(0.97rem, 2vw, 1.08rem);
    }
    @media (max-width: 915px) {
      :root {
        --fz-lg: 1.35rem;
        --fz-md: 1.05rem;
        --fz-base: 0.97rem;
      }
    }
    @media (max-width: 640px) {
      :root {
        --fz-lg: 1.08rem;
        --fz-md: 0.97rem;
        --fz-base: 0.91rem;
      }
      .show-gallery-btn {
        padding: 0.5rem 1rem;
        font-size: var(--fz-base);
      }
    }
    .show-gallery-btn {
      padding: 0.75rem 1.5rem;
      font-size: var(--fz-md);
    }
  `;
  document.head.appendChild(style);
}
// src/app/page.tsx
// src/app/page.tsx
// Importy pro Next.js a Framer Motion
// Barvy: žlutá #FDC30F, tmavě modrá #1F2E46
// Import Framer Motion pro animace (viz níže)
import React, { useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import Script from 'next/script';
import { useCookieConsent } from './components/CookieContext';
declare global {
  interface Window {
    particlesJS?: any;
  }
}

// Seznam fotek galerie s popisem
const galerieImages = [
  {
    src: '/galerie/majaky1.webp',
    title: 'Výměna LED diod',
    description: 'Výměna LED osvětlení na světelné rampě',
    tag: 'Osvětlení',
  },
  {
    src: '/galerie/maly_rozvadec1.webp',
    title: 'Podružný rozvaděč',
    description: 'Montáž, osazení potřebných prvků a kabeláž',
    tag: 'Rozvaděče',
  },
  {
    src: '/galerie/3dtisk1.webp',
    title: 'Zakázkový 3D tisk',
    description: 'Zakázkový 3D tisk na míru od reklamních produktů až po technické díly.',
    tag: '3D tisk',
  },
];

// Ikonky sociálních sítí a mobilu
const icons = {
  instagram: '/icons/instagram (1).png',
  facebook: '/icons/facebook (1).png',
  whatsapp: '/icons/whatsapp.png',
  phone: '/icons/mobile2.png',
  tiktok: '/icons/tiktok.png',
};

// Komponenta pro navigaci s hamburger menu (převzato z galerie)
import { AnimatePresence, motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);

      // Header se schová pouze pokud není otevřené menu
      if (open) {
        setIsVisible(true);
      } else if (scrollTop > lastScrollY && scrollTop > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, open]); // <- důležité!

  const menuItems = [
    { label: 'Služby', href: '/#sluzby' },
    { label: 'O mně', href: '/#o-nas' },
    { label: 'Galerie', href: '/galerie' },
    { label: 'Reference', href: '/#reference' },
    { label: 'Kontakt', href: '/#kontakt' },
  ];

  return (
    <>
      <header
          className="fixed w-full z-50 transition-all duration-500 top-4 px-4"
          style={{
            opacity: !open && isScrolled && !isVisible ? 0 : 1,
            transform: !open && isScrolled && !isVisible ? 'translateY(-150%)' : 'translateY(0)'
          }}
      >
        {/* Plovoucí kapsle s efektem rozmazaného skla */}
        <div className="max-w-6xl mx-auto px-6 flex justify-between items-center h-[72px] rounded-full shadow-lg backdrop-blur-md"
             style={{
               background: 'rgba(31, 46, 70, 0.85)', // Tmavě modrá s mírnou průhledností
               border: '1px solid rgba(253, 195, 15, 0.3)' // Jemný žlutý rámeček místo tvrdé linky
             }}>

          <a href="/" className="flex items-center gap-2 group logo-hover-animation" style={{ textDecoration: 'none' }}>
            <Image src="/galerie/Logo Elektroinstalace Trunec.png" alt="Logo Elektroinstalace Trunec" width={32} height={32} style={{ objectFit: 'contain', marginRight: 8 }} sizes="(max-width: 650px) 24px, 32px" priority />
            <span style={{ fontSize: '1.25rem', fontWeight: 700, fontFamily: 'var(--font-geist-sans, sans-serif)', color: '#FDC30F', letterSpacing: '0.04em', lineHeight: 1, display: 'block', textAlign: 'left' }}>
        Elektroinstalace<br />Trunec
      </span>
          </a>

          <nav className="hidden min-[960px]:flex gap-8">
            {menuItems.map((item) => (
                <a key={item.label} href={item.href} className="nav-underline transition-colors duration-300" style={{ color: '#ffffff', fontWeight: 600 }} onMouseEnter={(e) => e.currentTarget.style.color = '#FDC30F'} onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}>
                  {item.label}
                </a>
            ))}
          </nav>

          {/* Kulaté tlačítko zasazené do plovoucí kapsle */}
          <a href="tel:+420704280499" className="ml-4 px-5 py-2.5 rounded-full font-bold shadow transition-all duration-300 hover:scale-105 hover:shadow-2xl group hidden min-[960px]:inline-flex items-center" style={{ background: '#FDC30F', color: '#1F2E46' }}>
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92V19a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h2.09a2 2 0 0 1 2 1.72c.13.81.37 1.6.7 2.34a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.88 6.88l1.27-1.27a2 2 0 0 1 2.11-.45c.74.33 1.53.57 2.34.7A2 2 0 0 1 22 16.92z" /></svg>
            +420 704 280 499
          </a>

          <button className="min-[960px]:hidden z-50 flex flex-col justify-center items-center h-10 w-10 p-2 focus:outline-none" onClick={() => setOpen((prev) => !prev)} type="button">
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? 'rotate-45 translate-y-[3px]' : 'mb-1'}`} style={{ marginBottom: open ? 0 : 4 }}></span>
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? 'opacity-0' : 'mb-1'}`} style={{ marginBottom: open ? 0 : 4 }}></span>
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? '-rotate-45 -translate-y-[3px]' : ''}`}></span>
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
            <motion.nav
                // ZDE JE OPRAVA: Musíme Framer Motion říct, aby držel X na -50 % po celou dobu
                initial={{ y: -24, x: "-50%", opacity: 0 }}
                animate={{ y: 0, x: "-50%", opacity: 1 }}
                exit={{ y: -24, x: "-50%", opacity: 0 }}
                transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}

                className="fixed top-[100px] left-1/2 z-40 bg-[#1F2E46] px-6 pt-4 pb-4 flex flex-col space-y-2 shadow-xl rounded-[2.5rem]"
                style={{
                  // Vynutíme přesnou šířku displeje minus 32px (16px zleva, 16px zprava)
                  width: 'calc(100vw - 32px)',
                  maxWidth: '768px',
                  borderBottom: '2px solid #FDC30F',
                  boxShadow: '0 8px 32px 0 rgba(31,46,70,0.18)'
                }}
            >
              {menuItems.map((item) => (
                  <a
                      key={item.label}
                      href={item.href}
                      className="block py-2 text-center text-base border-b border-white/10 last:border-0 hover:text-[#fdc30f] transition"
                      style={{ color: '#fff', fontWeight: 600 }}
                      onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </a>
              ))}
            </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};

// Komponenta pro kontaktní formulář
function ContactForm() {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const messageRef = useRef<HTMLTextAreaElement>(null);
  const honeypotRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setSent(false);
    setSending(true);
    // Honeypot antispam
    if (honeypotRef.current?.value) {
      setError('Spam detekován.');
      setSending(false);
      return;
    }
    const name = nameRef.current?.value;
    const email = emailRef.current?.value;
    const message = messageRef.current?.value;
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message })
      });
      const data = await res.json();
      if (data.success) {
        setSent(true);
        if (nameRef.current) nameRef.current.value = '';
        if (emailRef.current) emailRef.current.value = '';
        if (messageRef.current) messageRef.current.value = '';
      } else {
        setError(data.error || 'Chyba při odesílání.');
      }
    } catch (err) {
      setError('Chyba při odesílání.');
    }
    setSending(false);
  };

  return (
    <motion.form
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      onSubmit={handleSubmit}
      className="contact-card"
    >
      <h4 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700, color: '#1F2E46' }}>Napište mi</h4>
      <label className="flex flex-col gap-1.5">
        <span className="text-[0.72rem] font-bold uppercase tracking-[0.12em] text-slate-500">Jméno</span>
        <input type="text" placeholder="Vaše jméno" name="name" ref={nameRef} className="contact-field" required />
      </label>
      <label className="flex flex-col gap-1.5">
        <span className="text-[0.72rem] font-bold uppercase tracking-[0.12em] text-slate-500">Email</span>
        <input type="email" placeholder="Váš email" name="email" ref={emailRef} className="contact-field" required />
      </label>
      <label className="flex flex-col gap-1.5">
        <span className="text-[0.72rem] font-bold uppercase tracking-[0.12em] text-slate-500">Zpráva</span>
        <textarea placeholder="Vaše zpráva" name="message" ref={messageRef} className="contact-field" style={{ height: 150, minHeight: 150, resize: 'vertical' }} required></textarea>
      </label>
      {/* Honeypot pole pro antispam, skryté pro uživatele */}
      <input type="text" name="company" ref={honeypotRef} style={{ display: 'none' }} autoComplete="off" tabIndex={-1} />
      <button type="submit" disabled={sending} className="contact-submit">
        {sending ? 'Odesílám...' : 'Odeslat zprávu'}
        <svg className="contact-submit-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ width: 20, height: 20 }}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </button>
      {sent && (
        <div className="contact-alert contact-alert-success">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ width: 18, height: 18, flexShrink: 0 }}>
            <path d="M20 6L9 17l-5-5" />
          </svg>
          Zpráva byla úspěšně odeslána.
        </div>
      )}
      {error && (
        <div className="contact-alert contact-alert-error">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ width: 18, height: 18, flexShrink: 0 }}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5M12 16h.01" />
          </svg>
          {error}
        </div>
      )}
    </motion.form>
  );
}

// Hlavní komponenta stránky
export default function Home() {
  const { consent, setConsent } = useCookieConsent();

  // Povolení cookies přímo ze sekce s recenzemi (alternativa k cookie liště dole).
  // Hodnota 'all' se uloží do localStorage přes CookieProvider a stránka se okamžitě překreslí.
  const handleEnableCookies = () => {
    setConsent('all');
  };
  
  // Krok 4: Načtení particles.js a inicializace v hero sekci - deferred for LCP
  useEffect(() => {
    // Defer particles.js loading to improve LCP
    const timer = setTimeout(() => {
      // Zabrání opakovanému načítání
      if (window.particlesJS) {
        window.particlesJS('particles-js', {
          particles: {
            number: { value: 80, density: { enable: true, value_area: 1200 } },
            color: { value: '#FDC30F' },
            shape: { type: 'circle' },
            opacity: { value: 0.3, random: true },
            size: { value: 3, random: true },
            line_linked: { enable: true, distance: 150, color: '#FDC30F', opacity: 0.2, width: 1 },
            move: { enable: true, speed: 1.2, direction: 'none', random: false, straight: false, out_mode: 'out', bounce: false }
          },
          interactivity: {
            detect_on: 'canvas',
            events: {
              onhover: { enable: true, mode: 'grab' },
              onclick: { enable: true, mode: 'push' },
              resize: true
            },
            modes: {
              grab: { distance: 200, line_linked: { opacity: 0.5 } },
              bubble: { distance: 200, size: 8, duration: 2, opacity: 0.8, speed: 3 },
              repulse: { distance: 200, duration: 0.4 },
              push: { particles_nb: 4 },
              remove: { particles_nb: 2 }
            }
          },
          retina_detect: true
        });
        return;
      }
      const script = document.createElement('script');
      script.src = '/libs/particles.min.js';
      script.async = true;
      script.onerror = () => {
        console.error('Failed to load particles.js');
      };
      script.onload = () => {
        if (window.particlesJS) {
          window.particlesJS('particles-js', {
            particles: {
              number: { value: 80, density: { enable: true, value_area: 1200 } },
              color: { value: '#FDC30F' },
              shape: { type: 'circle' },
              opacity: { value: 0.3, random: true },
              size: { value: 3, random: true },
              line_linked: { enable: true, distance: 150, color: '#FDC30F', opacity: 0.2, width: 1 },
              move: { enable: true, speed: 1.2, direction: 'none', random: false, straight: false, out_mode: 'out', bounce: false }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: { enable: true, mode: 'grab' },
                onclick: { enable: true, mode: 'push' },
                resize: true
              },
              modes: {
                grab: { distance: 200, line_linked: { opacity: 0.5 } },
                bubble: { distance: 200, size: 8, duration: 2, opacity: 0.8, speed: 3 },
                repulse: { distance: 200, duration: 0.4 },
                push: { particles_nb: 4 },
                remove: { particles_nb: 2 }
              }
            },
            retina_detect: true
          });
        }
      };
      document.body.appendChild(script);
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }, 2000); // Defer by 2 seconds to prioritize LCP

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="page-wrapper" style={{ fontFamily: 'sans-serif', color: '#1F2E46', background: '#fff' }}>
      <Navbar />
      <main style={{ paddingTop: '0px', minHeight: '100vh' }}>

      {/* Hero sekce ve žluté a tmavě modré */}
      <section id="hero" className="relative h-[45vh] min-h-[320px] flex items-center justify-center overflow-hidden" style={{ background: '#1F2E46', borderBottom: '8px solid #FDC30F' }}>
        {/* Particles.js background */}
        <div id="particles-js" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0 }}></div>
        {/* Pro šířku <= 450px bez animací, jinak s animacemi */}
        <div className="relative z-10 text-center text-white px-6 max-w-2xl mx-auto">
          <style>{`
  /* Společné pravidlo pro všechny velikosti:
     Sekce se vždy přizpůsobí velikosti vnitřního textu */
  #hero {
    height: auto !important;
    box-sizing: border-box !important;
    overflow: hidden !important; 
  }

  /* Mobilní zobrazení (vše do 475px) */
  @media (max-width: 475px) {
    #hero {
      min-height: 26.25rem !important;
      padding-top: 2rem !important;
      padding-bottom: 2.25rem !important;
    }
    .hero-motion { display: none !important; }
    .hero-static { display: block !important; }
  }

  /* Zobrazení pro tablety a PC (nad 476px) */
  @media (min-width: 476px) {
    #hero {
      /* Přidáno 6rem (cca 96px) odsazení shora, aby text nekolidoval s plovoucím menu */
      padding-top: 6rem !important; 
    }
    .hero-motion { display: block !important; }
    .hero-static { display: none !important; }
  }
`}</style>
          {/* Animace pro desktop/tablet */}
          <div className="hero-motion">
            <motion.h1 style={{ fontSize: '2.1rem', fontWeight: 800, marginBottom: '0.5rem', letterSpacing: '0.01em', lineHeight: 1.1, color: '#FDC30F' }}
              initial={{ opacity: 1, y: 0 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0 }}
            >Elektroinstalace Dominik Trunec</motion.h1>
            <motion.h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem', color: '#FDC30F', opacity: 0.95, letterSpacing: '0.01em' }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.2 }}
            >elektroinstalace • kompletace domovních rozvaděčů • zakázkový 3D tisk</motion.h2>
            <motion.p style={{ fontSize: '1.05rem', marginBottom: 0, color: '#fff', opacity: 0.92, lineHeight: 1.6, textShadow: '0 1px 4px #1F2E46' }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.1, delay: 0.4 }}
            >Jsem Dominik Trunec, elektrikář, který se zaměřuje na elektroinstalace, výrobu a montáž domovních rozvaděčů, instalaci osvětlení, 3D tisk na míru a mnohé další. </motion.p>
          </div>
          {/* Statický obsah pro mobil */}
          <div className="hero-static">
            <h1 style={{ fontSize: '2.1rem', fontWeight: 800, marginTop: '4.0rem', marginBottom: '0.5rem', letterSpacing: '0.01em', lineHeight: 1.1, color: '#FDC30F' }}>Elektroinstalace Trunec – Dominik Trunec</h1>
            <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem', color: '#FDC30F', opacity: 0.95, letterSpacing: '0.01em' }}>elektroinstalace • kompletace domovních rozvaděčů • zakázkový 3D tisk • Trunec</h2>
            <p style={{ fontSize: '1.05rem', marginBottom: '2.0rem', color: '#fff', opacity: 0.92, lineHeight: 1.6, textShadow: '0 1px 4px #1F2E46' }}>Jsem Dominik Trunec, elektrikář, který se zaměřuje na elektroinstalace, výrobu a montáž domovních rozvaděčů, instalaci osvětlení, 3D tisk na míru a mnohé další.</p>
          </div>
        </div>
      </section>

      {/* Sekce Služby ve žluté a tmavě modré */}
      <section id="sluzby" style={{ padding: '5rem 0', background: '#F8FAFC' }}>
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: 'center', marginBottom: '4rem' }}
          >
            <h3 style={{ fontSize: '2.1rem', fontWeight: 700, marginBottom: '1rem', color: '#1F2E46', letterSpacing: '0.01em' }}>
              Nabízené služby
            </h3>
            <p style={{ fontSize: '1.25rem', color: '#1F2E46', maxWidth: 768, margin: '0 auto' }}>
              Moderní přístup k elektrotechnice s důrazem na kvalitu, bezpečnost a inovace
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Služba 1: Elektroinstalace */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-yellow-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-yellow-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" style={{ background: '#1F2E46' }}>
                  <span className="text-2xl" style={{ color: '#FDC30F' }}>⚡</span>
                </div>
                <h4 className="text-xl font-bold mb-4" style={{ color: '#1F2E46' }}>Elektroinstalace</h4>
                <p className="leading-relaxed" style={{ color: '#1F2E46' }}>Kompletní instalace, modernizace a opravy rozvodů v domech i firmách.</p>
              </div>
            </motion.div>

            {/* Služba 2: Rozvaděče */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-yellow-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-yellow-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl text-yellow-400">🌐</span>
                </div>
                <h4 className="text-xl font-bold mb-4 text-slate-800 group-hover:text-slate-900 transition-colors">Chytrá domácnost</h4>
                <p className="text-slate-600 leading-relaxed">Kompletní řešení chytré domácnosti s odbornou montáží a propojením zařízení přes platformy Apple Home a Google Home.</p>
              </div>
            </motion.div>

            {/* Služba 3: Osvětlení */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-yellow-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-yellow-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl text-yellow-400">💡</span>
                </div>
                <h4 className="text-xl font-bold mb-4 text-slate-800 group-hover:text-slate-900 transition-colors">LED & Smart osvětlení</h4>
                <p className="text-slate-600 leading-relaxed">Montáž stropních svítidel, kompletace vypínačů, instalace LED osvětlení s chytrým ovládáním.</p>
              </div>
            </motion.div>

            {/* Služba 4: 3D tisk */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-yellow-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-yellow-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl text-yellow-400">🖥️</span>
                </div>
                <h4 className="text-xl font-bold mb-4 text-slate-800 group-hover:text-slate-900 transition-colors">3D tisk na míru</h4>
                <p className="text-slate-600 leading-relaxed">Tisk technických součástek, reklamních předmětů, figurek a mnoha dalších produktů z běžných i mechanicky odolných materiálů.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sekce O mně ve žluté a tmavě modré */}
      <section id="o-nas" style={{ padding: '5rem 0', background: '#1F2E46' }}>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h3
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ fontSize: '2.1rem', fontWeight: 700, marginBottom: '2rem', color: '#FDC30F', letterSpacing: '0.01em' }}
          >
            O mně
          </motion.h3>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            style={{ fontSize: 'var(--fz-base)', color: '#fff', lineHeight: 1.6, maxWidth: 768, margin: '0 auto' }}
          >
            Jmenuji se Dominik Trunec, jsem elektrikář se zájmem o techniku, nové technologie a 3D tisk. Moje jméno najdete za kvalitní elektroinstalací v Pardubickém kraji. Vystudoval jsem SPŠE v Pardubicích obor elektrikář s výučním listem a následně nástavbu zakončenou maturitou. Během studia jsem nasbíral přes čtyři roky praxe na brigádách i při samostatných zakázkách, které mi daly cenné zkušenosti. Elektrotechnice se věnuji i ve volném čase a rád se učím nové věci.          </motion.p>
        </div>
      </section>

      {/* Sekce Galerie - Fotky realizovaných prací */}
      <section id="galerie" style={{ padding: '4rem 0', background: '#fff' }}>
        <div className="max-w-6xl mx-auto px-6">
          <motion.h3
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ fontSize: '2.1rem', fontWeight: 700, textAlign: 'center', marginBottom: '2.5rem', color: '#1F2E46', letterSpacing: '0.01em' }}
          >
            Galerie realizovaných prací
          </motion.h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {galerieImages.map((img, i) => (
              <motion.div
                key={img.src}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 + 0.12 * i }}
              >
                <a
                  href={`/galerie?project=${i}`}
                  className="group relative block overflow-hidden rounded-3xl ring-1 ring-slate-200 shadow-lg transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:ring-2 hover:ring-[#FDC30F] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FDC30F]"
                  style={{ textDecoration: 'none', background: '#1F2E46' }}
                  aria-label={`Zobrazit detail projektu: ${img.title}`}
                >
                  <div className="relative aspect-[4/3] w-full overflow-hidden">
                    {/* Obrázek jako pozadí */}
                    <Image
                      src={img.src}
                      alt={`Galerie: ${img.title} | Elektroinstalace Trunec`}
                      fill
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                      className="object-cover transition-transform duration-700 ease-out group-hover:scale-[1.07]"
                      loading={i < 1 ? 'eager' : 'lazy'}
                      fetchPriority={i < 1 ? 'high' : 'auto'}
                      placeholder="blur"
                      blurDataURL="/galerie/placeholder.webp"
                      decoding="async"
                    />
                    {/* Gradient pro čitelnost textu */}
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(31,46,70,0.96) 0%, rgba(31,46,70,0.55) 45%, rgba(253,195,15,0.10) 100%)', zIndex: 2 }}></div>
                    {/* Kategorie realizace */}
                    <span
                      className="absolute z-10 inline-flex items-center"
                      style={{ top: 16, left: 16, padding: '0.35rem 0.85rem', borderRadius: 999, background: 'rgba(253,195,15,0.95)', color: '#1F2E46', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', boxShadow: '0 6px 18px -6px rgba(31,46,70,0.7)' }}
                    >
                      {img.tag}
                    </span>
                    {/* Text karty ukotvený u spodní hrany */}
                    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 3, padding: '1.25rem 1.35rem' }}>
                      <h4 className="text-xl font-extrabold" style={{ marginBottom: '0.5rem', letterSpacing: '0.01em', color: '#FDC30F', textShadow: '0 2px 8px rgba(31,46,70,0.55)' }}>{img.title}</h4>
                      <p className="line-clamp-2 text-sm sm:text-base leading-relaxed text-slate-100">{img.description}</p>
                      <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold" style={{ color: '#FDC30F' }}>
                        Zobrazit detail
                        <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </a>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.8 }}
            className="text-center mt-10"
          >
            <p style={{ color: '#1F2E46', fontSize: '1.125rem' }}>
              Chcete vidět více realizovaných prací?
            </p>
          </motion.div>
          <div className="flex justify-center mt-4">
            <a href="/galerie" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.75rem 1.5rem', borderRadius: 8, background: '#1F2E46', color: '#FDC30F', fontWeight: 700, fontSize: '1.125rem', boxShadow: '0 2px 8px #1F2E46' }}>
              Zobrazit galerii
              <span className="ml-1">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* Sekce Reference - S animacemi pro každou referenci */}
      <section id="reference" style={{ padding: '4rem 0', background: '#F8FAFC' }}>
        <div className="max-w-6xl mx-auto px-6">
          {/* Widget Firmy.cz doprostřed */}

          <motion.h3
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ fontSize: '1.7rem', fontWeight: 700, textAlign: 'center', marginBottom: '2.5rem', color: '#FDC30F', letterSpacing: '0.01em' }}
          >
            Co o mně říkají zákazníci
          </motion.h3>
          <div className="flex justify-center mb-10">
            {consent === 'all' ? (
              <iframe width="100%" height="320" src="https://www.firmy.cz/detail/13862207-elektroinstalace-trunec-hrochuv-tynec.html?widget&limit=3" style={{ border: 'none', minWidth: '240px', maxWidth: '100%' }} frameBorder="0" title="Reference Elektroinstalace Trunec na Firmy.cz" loading="lazy"></iframe>
            ) : (
              /* Návštěvník ještě nepovolil cookies - nabídneme mu je zapnout přímo tady */
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                style={{ width: '100%', maxWidth: 720, padding: '2.5rem 1.75rem', borderRadius: 24, background: '#fff', border: '1px solid rgba(31,46,70,0.10)', boxShadow: '0 18px 40px -26px rgba(31,46,70,0.45)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', textAlign: 'center' }}
              >
                <span
                  aria-hidden="true"
                  style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: '50%', background: 'rgba(253,195,15,0.16)', border: '1px solid rgba(253,195,15,0.55)' }}
                >
                  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="#1F2E46" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 3l2.9 5.9 6.5.94-4.7 4.58 1.11 6.48L12 17.77 6.19 20.9 7.3 14.42 2.6 9.84l6.5-.94L12 3z" />
                  </svg>
                </span>
                <h4 style={{ margin: 0, color: '#1F2E46', fontSize: 'var(--fz-md)', fontWeight: 700 }}>
                  Recenze se zobrazí po povolení cookies
                </h4>
                <p style={{ margin: 0, maxWidth: 520, color: '#475569', fontSize: 'var(--fz-base)', lineHeight: 1.6 }}>
                  Hodnocení od zákazníků načítáme přes widget portálu Firmy.cz, který používá soubory cookies třetích stran.
                  Souhlas je dobrovolný – web funguje i bez něj, recenze vám ale ukázat nemůžeme.
                </p>
                <button
                  type="button"
                  onClick={handleEnableCookies}
                  className="show-gallery-btn inline-flex items-center gap-3 rounded-2xl font-bold shadow-lg transition-all duration-300 hover:scale-[1.04] hover:shadow-2xl"
                  style={{ background: '#FDC30F', color: '#1F2E46', border: 'none', cursor: 'pointer' }}
                >
                  Zapnout cookies a zobrazit recenze
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M5 12h14M13 6l6 6-6 6" />
                  </svg>
                </button>
                <span style={{ color: '#64748B', fontSize: '0.85rem' }}>
                  Nastavení můžete kdykoli změnit nebo souhlas odvolat – volba se ukládá do vašeho prohlížeče.
                </span>
              </motion.div>
            )}
          </div>
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-stretch justify-center">
            {/* Dva sloupce pod widgetem */}
            <div className="flex-1 flex flex-col justify-center items-end md:items-end md:pr-4">
              {/* Elfsight recenze widget - commented out to reduce third-party cookies */}
              {/* <Script src="https://static.elfsight.com/platform/platform.js" strategy="lazyOnload" /> */}
              {/* <div className="elfsight-app-d44e6981-b1c5-4518-b1cd-7e5abf31aff2" data-elfsight-app-lazy></div> */}
            </div>
            <div className="flex-1 flex flex-col justify-center items-start md:items-start md:pl-4 gap-4">
              {/* Tlačítko Firmy.cz */}
              {consent === 'all' && (
                <a href="https://www.firmy.cz/detail/13862207-elektroinstalace-trunec-hrochuv-tynec.html#pridat-hodnoceni" target="_blank" rel="noopener">
                  <Image width={249} height={56} src="https://www.firmy.cz/img/widgets/firmy-ohodnotte-nas-svetle.svg" alt="Elektroinstalace Trunec na Firmy.cz" loading="lazy" />
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Sekce Kontakt - moderní karty s formulářem a kontakty */}
      <section id="kontakt" style={{ padding: '5rem 0', background: '#F8FAFC' }}>
        <div className="max-w-6xl mx-auto px-6">
          {/* Sdílené styly pro kontaktní sekci */}
          <style>{`
            .contact-card { width: 100%; display: flex; flex-direction: column; gap: 1.25rem; background: #fff; border: 1px solid rgba(31, 46, 70, 0.10); border-radius: 24px; padding: 2rem; box-shadow: 0 18px 40px -26px rgba(31, 46, 70, 0.45); }
            .contact-field { width: 100%; padding: 0.85rem 1rem; border: 1px solid #E2E8F0; border-radius: 14px; background: #F8FAFC; color: #1F2E46; font-size: 1rem; font-family: inherit; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease; }
            .contact-field::placeholder { color: #94A3B8; }
            .contact-field:focus { border-color: #FDC30F; background: #fff; box-shadow: 0 0 0 4px rgba(253, 195, 15, 0.22); }
            .contact-submit { width: 100%; display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; padding: 0.9rem 1.5rem; border: none; border-radius: 16px; background: #FDC30F; color: #1F2E46; font-size: 1rem; font-weight: 700; font-family: inherit; cursor: pointer; transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease; box-shadow: 0 12px 26px -14px rgba(253, 195, 15, 0.95); }
            .contact-submit:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 18px 34px -16px rgba(253, 195, 15, 1); }
            .contact-submit:disabled { opacity: 0.7; cursor: progress; }
            .contact-submit-arrow { transition: transform 0.3s ease; }
            .contact-submit:hover:not(:disabled) .contact-submit-arrow { transform: translateX(4px); }
            .contact-tile { display: flex; align-items: center; gap: 0.85rem; padding: 0.85rem 1rem; border: 1px solid rgba(31, 46, 70, 0.10); border-radius: 18px; background: #fff; text-decoration: none; transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease; }
            .contact-tile:hover { transform: translateY(-2px); border-color: #FDC30F; box-shadow: 0 16px 30px -20px rgba(31, 46, 70, 0.65); }
            .contact-tile-icon { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; flex-shrink: 0; border-radius: 12px; background: #F8FAFC; border: 1px solid rgba(31, 46, 70, 0.08); }
                  .contact-tile-label { display: block; font-size: 0.7rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #64748B; }
            .contact-tile-value { display: block; font-size: 0.95rem; font-weight: 700; color: #1F2E46; overflow-wrap: anywhere; }
            .contact-group-title { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: #94A3B8; margin-bottom: 0.75rem; }
            .contact-alert { display: flex; align-items: center; gap: 0.5rem; padding: 0.75rem 1rem; border-radius: 14px; font-size: 0.9rem; font-weight: 600; }
            .contact-alert-success { background: rgba(22, 163, 74, 0.10); border: 1px solid rgba(22, 163, 74, 0.25); color: #15803D; }
            .contact-alert-error { background: rgba(220, 38, 38, 0.08); border: 1px solid rgba(220, 38, 38, 0.25); color: #B91C1C; }
          `}</style>

          {/* Formulář a kontakty vedle sebe */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-stretch">
            <ContactForm />
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 }}
                className="contact-card"
            >
              <h4 style={{ margin: 0, marginBottom: '16px', fontSize: '1.25rem', fontWeight: 700, color: '#1F2E46' }}>Kontakty a odkazy</h4>

              {/* Všechny položky jsou nyní v jedné společné mřížce s jednotnou mezerou gap-2.5 */}
              <div className="grid grid-cols-1 gap-2.5">
                <a href="tel:+420704280499" className="contact-tile">
                  <span className="contact-tile-icon"><Image src={icons.phone} alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">Telefon</span>
          <span className="contact-tile-value">+420 704 280 499</span>
        </span>
                </a>

                <a href="mailto:info@elektroinstalacetrunec.cz" className="contact-tile">
                  <span className="contact-tile-icon"><Image src="/icons/email.png" alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">Email</span>
          <span className="contact-tile-value">info@elektroinstalacetrunec.cz</span>
        </span>
                </a>

                <a href="https://wa.me/420704280499" target="_blank" rel="noopener noreferrer" className="contact-tile">
                  <span className="contact-tile-icon"><Image src={icons.whatsapp} alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">WhatsApp</span>
          <span className="contact-tile-value">+420 704 280 499</span>
        </span>
                </a>

                <a href="https://instagram.com/trunec_elektroinstalace" target="_blank" rel="noopener noreferrer" className="contact-tile">
                  <span className="contact-tile-icon"><Image src={icons.instagram} alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">Instagram</span>
          <span className="contact-tile-value">@trunec_elektroinstalace</span>
        </span>
                </a>

                <a href="https://facebook.com/trunec_elektroinstalace" target="_blank" rel="noopener noreferrer" className="contact-tile">
                  <span className="contact-tile-icon"><Image src={icons.facebook} alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">Facebook</span>
          <span className="contact-tile-value">fb.com/trunec_elektroinstalace</span>
        </span>
                </a>

                <a href="https://www.tiktok.com/@trunec_elektroinstalace" target="_blank" rel="noopener noreferrer" className="contact-tile">
                  <span className="contact-tile-icon"><Image src={icons.tiktok} alt="" width={22} height={22} /></span>
                  <span style={{ minWidth: 0 }}>
          <span className="contact-tile-label">TikTok</span>
          <span className="contact-tile-value">@trunec_elektroinstalace</span>
        </span>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Footer ve žluté a tmavě modré */}
        <footer style={{ background: '#1F2E46', borderTop: '2px solid #FDC30F' }}>
          <style>{`
    .footer-text { color: rgba(255, 255, 255, 0.75); font-size: 0.95rem; }
    .footer-link { color: rgba(255, 255, 255, 0.75); text-decoration: none; transition: color 0.2s ease; }
    .footer-link:hover { color: #fff; text-decoration: underline; text-underline-offset: 4px; }
  `}</style>

          {/* Sníženo vnitřní odsazení (padding) pro zmenšení celkové výšky */}
          <div className="max-w-6xl mx-auto px-6" style={{ padding: '1rem 1.5rem' }}>

            {/* Kontaktní údaje zarovnané přesně na střed, jednotný font a barvy */}
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 footer-text">
              <span>IČO: 23403195</span>

              {/* Oddělovací tečka (viditelná jen na větších obrazovkách) */}
              <span className="hidden md:inline-block w-1.5 h-1.5 rounded-full bg-white opacity-20"></span>

              <a href="tel:+420704280499" className="footer-link">+420 704 280 499</a>

              {/* Oddělovací tečka */}
              <span className="hidden md:inline-block w-1.5 h-1.5 rounded-full bg-white opacity-20"></span>

              <a href="mailto:info@elektroinstalacetrunec.cz" className="footer-link">info@elektroinstalacetrunec.cz</a>
            </div>

            {/* Spodní lišta - sníženy mezery marginTop a paddingTop nad a pod čarou */}
            <div className="flex justify-center" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.12)' }}>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.55)', fontSize: '0.85rem', textAlign: 'center' }}>
                © 2026 <span style={{ color: '#fff', fontWeight: 700 }}>Elektroinstalace Trunec</span>. Powered by{' '}
                <a href="https://www.instagram.com/zdenek_pesa" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#fff', fontWeight: 600 }}>Zdeněk Pešek</a>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}
